import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/hands-agent-client-shaking-hands-after-signed-contract-buy-new-apartment_1150-14835.jpg';

function TenantRightsRentalAssistance() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Tenant Rights and Rental Assistance" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Tenant Rights and Rental Assistance</h4>
              <p>
                This sub-department is dedicated to supporting tenants by providing resources, rental assistance programs, and educational initiatives on tenant rights.<br />
                Services include eviction prevention, mediation support, and advocacy for fair housing practices.<br /><br />
                Our goal is to ensure secure housing and empower tenants with the knowledge and tools needed to protect their rights.
              </p>
            </div>

            <div className="department-details-benefits-box">
              <h3>Key Services</h3>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Eviction Prevention Programs</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Mediation and Tenant Advocacy</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Rental Assistance Initiatives</h5>
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Our Commitment:</h4>
              <p>
                We are committed to fostering stable housing environments by providing comprehensive support and advocacy for tenants in need.
              </p>
            </div>
            <div>
              <Link to="/department/housing">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default TenantRightsRentalAssistance;
